import {Injectable} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";

@Injectable()
export class RefWorksService {
    private popupWin: Window;

    constructor(private pushtoService: PushtoService){

    }

    public refworksAction(item, selectedIds){
        this.popupWin = window.open('', '_blank');
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'refworks');
        pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }

    private successfullPushtoAction(response) {
        let serviceUrl = response.data.serviceUrl;
        let data = response.data.data;


        this.popupWin.document.open();
        this.popupWin.document.write('<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="document.getElementById(\'exportForm\').submit();"><FORM accept-charset="UTF-8" name="ExportForm" id="exportForm" method="POST" target="_parent"  style="display:none" action="' + serviceUrl + '">' + data + '</body>' + '</html>');
        this.popupWin.document.close();
        console.log("Refworks successfully sent");
    }

    private failedPushtoAction(event, response) {
        console.log("Refworks call failed");
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/refworksAction/refworks.service.ts